module.exports = __webpack_public_path__ + "static/media/prep-2.fb72f5f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/prep-2.jpg
// module id = 163
// module chunks = 0